import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from './LanguageSwitcher';

export function Footer() {
    const { t } = useTranslation();
    const year = new Date().getFullYear();

    return (
        <footer className="bg-slate-950 border-t border-white/10 py-8">
            <div className="max-w-7xl mx-auto px-6">
                <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                    <div className="flex items-center gap-2">
                        <div className="w-6 h-6 rounded bg-gradient-to-br from-emerald-400 to-cyan-500 flex items-center justify-center text-white font-black text-[10px]">
                            CS
                        </div>
                        <span className="text-sm text-white/50">
                            &copy; {year} {t('brand')}. {t('footer.rights')}
                        </span>
                    </div>

                    <div className="flex items-center gap-6">
                        <span className="text-xs text-white/40">{t('footer.privacy')}</span>
                        <span className="text-xs text-white/40">{t('footer.terms')}</span>
                        <div className="flex items-center gap-2">
                            <span className="text-xs text-white/40">{t('footer.language')}:</span>
                            <LanguageSwitcher />
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
